import axios from 'axios';
import store from '../store';
import router from '../router';

const api = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL}/api/`,
});

api.interceptors.response.use(
  (request) => request,
  async (error) => {
    const { response, config } = error;
    
    if (!config.url.includes('login') && !config.url.includes('logout') && response.status === 401) {     
      await store.dispatch('expire_session')
        .then(() => router.push('/login') )
        .catch(() => router.push('/login') );
    }

    return Promise.reject(error);
  }
);

export default api;
